import { Controller } from "@hotwired/stimulus";

export default class Dialog extends Controller {
  static targets = ["modal"];

  open() {
    this.modalTarget.showModal();
  }

  close() {
    this.modalTarget.close();
  }

  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.close();
    }
  }
}
